import { render, staticRenderFns } from "./UserCabinet.vue?vue&type=template&id=1a51c7bc"
import script from "./UserCabinet.vue?vue&type=script&lang=js"
export * from "./UserCabinet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports